import AddEditStipulationsFormModal from './AddEditStipulationsFormModal'
export default AddEditStipulationsFormModal
